import { useEffect, useState } from "react";
import { BSPORT } from "@/data/config";

const CDN_ID = "bsport-widget-cdn";
const CDN_SRC = "https://cdn.bsport.io/scripts/widget.js";

function ensureCdn() {
  if (document.getElementById(CDN_ID)) return;
  const s = document.createElement("script");
  s.id = CDN_ID;
  s.src = CDN_SRC;
  document.head.appendChild(s);
}

// Mounts a Bsport embedded widget (calendar / shop / pass).
// `fallback` renders an on-brand panel until the widget actually populates
// (e.g. on the preview domain where Bsport's API is locked to maisoncore.nl).
export function BsportWidget({ mountId, widgetType, config = {}, className = "", fallback = null, minReady = 300, minHeight = 480 }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    ensureCdn();
    let cancelled = false;
    const mount = (repeat = 1) => {
      if (cancelled || repeat > 60) return;
      if (!window.BsportWidget) {
        setTimeout(() => mount(repeat + 1), 100 * repeat);
        return;
      }
      window.BsportWidget.mount({
        parentElement: mountId,
        companyId: BSPORT.COMPANY_ID,
        franchiseId: null,
        dialogMode: 1,
        widgetType,
        showFab: false,
        fullScreenPopup: false,
        styles: undefined,
        config,
      });
    };
    mount();

    let obs, iv;
    if (fallback) {
      const el = document.getElementById(mountId);
      const check = () => {
        if (el && (el.querySelector("iframe") || el.offsetHeight >= minReady)) setReady(true);
      };
      if (el) {
        obs = new MutationObserver(check);
        obs.observe(el, { childList: true, subtree: true, attributes: true });
        iv = setInterval(check, 600);
        setTimeout(() => iv && clearInterval(iv), 14000);
      }
    }
    return () => { cancelled = true; obs && obs.disconnect(); iv && clearInterval(iv); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mountId, widgetType]);

  return (
    <div className="relative" style={fallback && !ready ? { minHeight } : undefined}>
      {fallback && !ready && <div className="absolute inset-0 z-20" data-testid={`bsport-fallback-${widgetType}`}>{fallback}</div>}
      <div id={mountId} className={className} data-testid={`bsport-${widgetType}`} />
    </div>
  );
}
